import { BiometricDataApi, Configuration, ImagesApi, JanusApi, ManagementApi, OperationsApi, SubjectsApi } from "neurotec-megamatcherid-management-client"
import { getFullApiUrl } from "../../config/management-api"

export interface APIsState {
    JanusApi: JanusApi,
    ManagementApi: ManagementApi,
    SubjectsApi: SubjectsApi,
    OperationsApi: OperationsApi,
    ImagesApi: ImagesApi,
    BiometricDataApi: BiometricDataApi,
}

export const initAPIsState: APIsState = {
    JanusApi: new JanusApi(new Configuration({basePath: getFullApiUrl()})),
    ManagementApi: new ManagementApi(new Configuration({basePath: getFullApiUrl()})),
    SubjectsApi: new SubjectsApi(new Configuration({basePath: getFullApiUrl()})),
    OperationsApi: new OperationsApi(new Configuration({basePath: getFullApiUrl()})),
    ImagesApi: new ImagesApi(new Configuration({basePath: getFullApiUrl()})),
    BiometricDataApi: new BiometricDataApi(new Configuration({basePath: getFullApiUrl()})),
}